module.exports = __webpack_public_path__ + "static/media/pic6.966e7040.webp";